/**
 * WbState — de drie staten van een lijst of detail in één component.
 *
 * laden   mono "…laden"
 * leeg    kop in font-wb-heading ("Alle voorinspecties gedaan.")
 * fout    tekst in geld-rood + Opnieuw-knop
 * Een offline-waarschuwing bij wél data is een WbFlag 'opmerking' op de
 * pagina zelf; deze component is voor de lege toestand.
 */

import { WbButton } from './WbButton';
import clsx from 'clsx';

export interface WbStateProps {
  variant: 'laden' | 'leeg' | 'fout';
  titel?: string;
  tekst?: string | null;
  onOpnieuw?: () => void;
  children?: React.ReactNode;
  className?: string;
}

export function WbState({ variant, titel, tekst, onOpnieuw, children, className }: WbStateProps) {
  if (variant === 'laden') {
    return <p className={clsx('font-mono text-wb-inkt2 py-4', className)}>{titel ?? 'Laden…'}</p>;
  }
  if (variant === 'fout') {
    return (
      <div className={clsx('space-y-2 py-2', className)} role="alert">
        <p className="font-semibold text-wb-geldink">{titel ?? tekst ?? 'Er ging iets mis.'}</p>
        {titel && tekst && <p className="text-sm text-wb-inkt2">{tekst}</p>}
        {onOpnieuw && <WbButton variant="secondary" onClick={onOpnieuw}>Opnieuw proberen</WbButton>}
        {children}
      </div>
    );
  }
  return (
    <div className={clsx('space-y-2 py-4', className)}>
      <p className="font-wb-heading font-bold text-lg text-wb-inkt">{titel ?? 'Niets te doen.'}</p>
      {tekst && <p className="text-sm text-wb-inkt2">{tekst}</p>}
      {children}
    </div>
  );
}
